import { useRef, useState } from 'react';
import styled from 'styled-components';
import { Input } from './ui';
import { useSelector } from 'react-redux';
import { registerCS } from '../api/services/customerService';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 50px;
  padding: 20px 3%;
  width: 50%;
  border: 1px solid ${(props) => props.theme.colors.subBackground};
  border-radius: 5px;

  @media (max-width: 768px) {
    width: 90%;
    padding: 20px 5%;
    margin-top: 20px;
    margin-bottom: 30px;
  }

  @media (max-width: 480px) {
    width: 95%;
    padding: 15px 3%;
    margin-top: 15px;
    margin-bottom: 20px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  width: 80%;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 480px) {
    width: 90%;
  }
`;

const InputContainer = styled.div`
  width: 80%;
  border: 1px solid #ccc;
  margin-bottom: 20px;

  @media (max-width: 480px) {
    width: 90%;
    margin-bottom: 15px;
  }
`;

const MenuTitleText = styled.p`
  font-size: 15px;
  font-weight: 700;
  white-space: pre;
  text-align: center;

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const ResizableTextarea = styled.textarea`
  width: 78%;
  padding: 10px;
  margin-bottom: 20px;
  min-height: 150px;
  max-height: 300px;
  font-size: 1rem;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: vertical;
  overflow: auto;

  &:focus {
    outline: none;
  }

  @media (max-width: 480px) {
    width: 86%;
    min-height: 120px;
    font-size: 0.9rem;
    margin-bottom: 15px;
  }
`;

const FileInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  margin-bottom: 20px;
  gap: 0;

  @media (max-width: 480px) {
    width: 90%;
    margin-bottom: 15px;
  }
`;

const FileListWrapper = styled.div`
  width: 80%;
  background-color: #f4f4f4;
  border: 1px solid #ddd;
  border-radius: 10px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    width: 100%;
  }

  @media (max-width: 480px) {
    width: 90%;
    margin-bottom: 15px;
  }
`;

const FileItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  border-bottom: 1px solid #eee;
  padding: 10px;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    padding: 8px;
  }
`;

const FileName = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;

  &::before {
    content: '📄';
  }

  @media (max-width: 768px) {
    max-width: 200px;
  }

  @media (max-width: 480px) {
    max-width: 150px;
    gap: 5px;
  }
`;

const RemoveButton = styled.button`
  border: none;
  background: transparent;
  color: #999;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    color: #d00;
  }
`;

const HiddenFileInput = styled.input`
  display: none;
`;

const UploadButton = styled.button`
  padding: 10px;
  width: 100%;
  max-height: 50px;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.colors.primaryBlue};
  color: white;
  font-weight: 600;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.2s ease;
  white-space: nowrap;
  margin-bottom: 15px;

  &:hover {
    opacity: 0.85;
  }

  @media (max-width: 480px) {
    max-height: none;
    font-size: 14px;
    padding: 12px;
  }
`;

const SubmitButton = styled.button`
  width: 80%;
  padding: 12px;
  background: ${(props) => props.theme.colors.primaryBlue};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 600;
  margin-top: 50px;

  &:hover {
    opacity: 0.7;
  }

  @media (max-width: 768px) {
    margin-top: 30px;
  }

  @media (max-width: 480px) {
    width: 90%;
    padding: 14px;
    margin-top: 20px;
    font-size: 16px;
  }
`;

export default function ContactUsForm({ style }) {
  const fileInputRef = useRef(null);

  const userInfo = useSelector((state) => state.userInfo);

  const [firstName, setFirstName] = useState(userInfo.firstname);
  const [lastName, setLastName] = useState(userInfo.lastname);
  const [email, setEmail] = useState(userInfo.email);
  const [message, setMessage] = useState('');
  const [files, setFiles] = useState([]);

  const handleFileChange = (e) => {
    setFiles([...e.target.files]);
  };

  const handleSubmit = async () => {
    if (message.length > 10) {
      const formData = new FormData();
      formData.append('destination', `custService/${userInfo.idCustomer}`);
      files.forEach((file) => formData.append('files', file));
      formData.append(
        'csInfo',
        JSON.stringify({
          idCustomer: userInfo.idCustomer,
          firstname: firstName,
          lastname: lastName,
          email,
          message,
        }),
      );
      const response = await registerCS(formData);
      if (response.is_success) {
        alert('Submit Successful!');
        window.location.reload();
      }
    } else {
      alert('Please enter a message of at least 10 characters');
    }
  };

  return (
    <Content style={style}>
      <TitleContainer>
        <MenuTitleText>First Name:</MenuTitleText>
        <MenuTitleText>*</MenuTitleText>
      </TitleContainer>
      <InputContainer>
        <Input
          type='text'
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
      </InputContainer>

      <TitleContainer>
        <MenuTitleText>Last Name:</MenuTitleText>
        <MenuTitleText>*</MenuTitleText>
      </TitleContainer>
      <InputContainer>
        <Input
          type='text'
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
      </InputContainer>

      <TitleContainer>
        <MenuTitleText>Your email:</MenuTitleText>
        <MenuTitleText>*</MenuTitleText>
      </TitleContainer>
      <InputContainer>
        <Input
          type='text'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </InputContainer>

      <TitleContainer>
        <MenuTitleText>Message:</MenuTitleText>
        <MenuTitleText>*</MenuTitleText>
      </TitleContainer>
      <ResizableTextarea
        placeholder='Please write a message here'
        value={message}
        onChange={(e) => setMessage(e.target.value)}
      />

      <FileInputWrapper>
        <UploadButton
          onClick={() => {
            if (fileInputRef.current) {
              fileInputRef.current.click();
            }
          }}
        >
          📁 Upload Files
        </UploadButton>
        <HiddenFileInput
          id='file-upload'
          type='file'
          ref={fileInputRef}
          multiple={true}
          onChange={handleFileChange}
        />
      </FileInputWrapper>

      {files.length > 0 && (
        <FileListWrapper>
          {files.map((file, idx) => (
            <FileItem key={idx}>
              <FileName>{file.name}</FileName>
              <RemoveButton
                onClick={() => {
                  const newFiles = [...files];
                  newFiles.splice(idx, 1);
                  setFiles(newFiles);
                }}
              >
                ✕
              </RemoveButton>
            </FileItem>
          ))}
        </FileListWrapper>
      )}

      <SubmitButton
        onClick={() => {
          handleSubmit();
        }}
      >
        SUBMIT
      </SubmitButton>
    </Content>
  );
}
